import { gatewayPhone } from "src/gateways/gatewayPhone";

export const getCallSettings = async (companyId: number) => {
    const response = await gatewayPhone.get(`company-call-config/${companyId}`);
    return response?.data;
};